export const styles = (theme: any) => {
    return {
        root: {
            //marginRight: '5px'

        },
        searchButtonContainer: {
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.only('xs')]: {
                justifyContent: 'center',
            }
        },
        searchButtons: {
            width: '100%',
            paddingLeft: '10px',
            display: 'flex'
        },
        searchButton: {
            marginLeft: '10px',
            marginRight: '10px',
        },
    }
}